import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, createSlots as _createSlots, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "hidden lg:flex w-20 rounded bg-white border-darken border-2 m-xs flex-col items-center justify-between" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "block text-center text-4xl font-semibold pt-m pb-s" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-profile h-profile"
}, null, -1)
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "absolute inline-flex overflow-x-visible items-center justify-center p-1 text-xs h-5 font-bold text-white bg-green rounded-xs top-xxs right-xxs dark:border-gray-900 aspect-square"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex flex-col mb-s" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "flex lg:hidden justify-between items-center bg-white px-s" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "block text-center text-4xl font-semibold pt-m pb-s pr-s" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-profile h-profile"
}, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "block lg:hidden fixed bottom-0 top-0 left-0 right-0 bg-white overflow-scroll z-50"
}
const _hoisted_18 = { class: "flex justify-between items-center px-s" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "block text-center text-4xl font-semibold pt-m pb-s pr-s" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-profile h-profile"
}, null, -1)
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "px-s" }, "Einstellungen", -1)
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "px-s" }, "Patienten", -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "px-s" }, "Bestellungen", -1)
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "px-s" }, "Lieferungen", -1)
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "px-s" }, "Logout", -1)

import { CareProviderGroup } from "@/interfaces/careProviderGroup";
import { supabase } from "@/helpers/supabase";
import ProfileCircle from "./ProfileCircle.vue";
import { ref } from "vue";
import { useOrdersStore } from "@/store/ordersStore";
import ToolTip from "./ToolTip.vue";
import ListTile from "./ListTile.vue";
import SmallTag from "./SmallTag.vue";
import IconButton from "./IconButton.vue";
import { newChatMessages } from "@/helpers/orderhelper";
import { Message } from "@/interfaces/message";


export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryNavigation',
  props: {
    selectedCareProviderGroup: {}
  },
  setup(__props: any) {

const ordersStore = useOrdersStore();

const props = __props;

const showMenu = ref<boolean>(false);

function toggleMenu() {
  showMenu.value = !showMenu.value;
}
function unreadMessages() {
  let unread = 0;
  for (let conversation of ordersStore.conversations ?? []) {
    const allMessages: Message[] = Array.from(
      ordersStore.messages?.values() ?? []
    );
    unread += newChatMessages(conversation[1], allMessages);
  }
  return unread > 9 ? "9+" : unread;
}

async function logout() {
  await supabase.auth.signOut();
  location.reload();
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createVNode(ProfileCircle, {
          "care-provider-group": props.selectedCareProviderGroup
        }, null, 8, ["care-provider-group"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ToolTip, {
          content: "Einstellungen",
          position: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/",
              class: "p-m"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('@/assets/icons/icon=cog, outlined=false.svg'),
                  type: "button"
                }, null, 8, _hoisted_6)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ToolTip, {
          content: "Patienten",
          position: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/managedPatients",
              class: "p-m"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('@/assets/icons/icon=contacts, outlined=false.svg')
                }, null, 8, _hoisted_7)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ToolTip, {
          content: "Bestellungen",
          position: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/conversations",
              class: "relative p-m"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('@/assets/icons/icon=cart, outlined=false.svg')
                }, null, 8, _hoisted_8),
                (unreadMessages() != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(unreadMessages()), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.selectedCareProviderGroup.is_shop)
          ? (_openBlock(), _createBlock(ToolTip, {
              key: 0,
              content: "Lieferungen",
              position: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: "/supplier",
                  class: "p-m"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: require('@/assets/icons/delivery-truck-3.svg')
                    }, null, 8, _hoisted_10)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(ToolTip, {
          content: "Logout",
          position: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (logout())),
              class: "px-m !bg-transparent"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('@/assets/icons/icon=logout, outlined=false.svg')
                }, null, 8, _hoisted_12)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        _createVNode(ProfileCircle, {
          "care-provider-group": props.selectedCareProviderGroup
        }, null, 8, ["care-provider-group"])
      ]),
      _createVNode(IconButton, {
        icon: "menu",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleMenu()))
      })
    ]),
    (showMenu.value)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", _hoisted_20, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                })
              ]),
              _createVNode(ProfileCircle, {
                "care-provider-group": props.selectedCareProviderGroup
              }, null, 8, ["care-provider-group"])
            ]),
            _createVNode(IconButton, {
              icon: "menu",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleMenu()))
            })
          ]),
          _createVNode(_component_router_link, {
            to: "/",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showMenu.value = false)),
            class: "px-m block w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(ListTile, { class: "w-full" }, {
                leading: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/icons/icon=cog, outlined=false.svg')
                  }, null, 8, _hoisted_22)
                ]),
                main: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/managedPatients",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showMenu.value = false)),
            class: "px-m block w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(ListTile, { class: "w-full" }, {
                leading: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/icons/icon=contacts, outlined=false.svg')
                  }, null, 8, _hoisted_24)
                ]),
                main: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/conversations",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (showMenu.value = false)),
            class: "px-m block w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(ListTile, { class: "w-full" }, _createSlots({
                leading: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/icons/icon=cart, outlined=false.svg')
                  }, null, 8, _hoisted_26)
                ]),
                main: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 2
              }, [
                (unreadMessages() != 0)
                  ? {
                      name: "trailing",
                      fn: _withCtx(() => [
                        _createVNode(SmallTag, { color: "green" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(unreadMessages()), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/supplier",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (showMenu.value = false)),
            class: "px-m block w-full"
          }, {
            default: _withCtx(() => [
              (_ctx.selectedCareProviderGroup.is_shop)
                ? (_openBlock(), _createBlock(ListTile, {
                    key: 0,
                    class: "w-full"
                  }, {
                    leading: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('@/assets/icons/delivery-truck-3.svg')
                      }, null, 8, _hoisted_28)
                    ]),
                    main: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (logout())),
            class: "px-m block w-full !bg-transparent"
          }, {
            default: _withCtx(() => [
              _createVNode(ListTile, { class: "w-full !bg-transparent" }, {
                leading: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/icons/icon=logout, outlined=false.svg')
                  }, null, 8, _hoisted_30)
                ]),
                main: _withCtx(() => [
                  _hoisted_31
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})